
import { AssetMaintenanceEntityDecoratorBase } from './asset-maintenance.decorator.base';


export class AssetMaintenanceEntityDecorator extends AssetMaintenanceEntityDecoratorBase {
  constructor() {
    super();
  }
}



